import React, { useCallback, useState } from "react";

import { copyToClipboard } from "../../utils/copyToClipboard";

import * as styles from "./PromptCard.module.css";

interface PromptCardProps {
  text: string;
}

export function PromptCard({ text }: PromptCardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    copyToClipboard(text).then((ok) => {
      if (!ok) return;
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [text]);

  return (
    <div className={styles.promptCard}>
      <span className={styles.promptLabel}>Prompt — Copy this into your AI</span>
      <button
        className={styles.promptCopyButton}
        onClick={handleCopy}
        type="button"
      >
        {copied ? "Copied!" : "Copy Full Prompt"}
      </button>
      <div className={styles.promptContent}>{text}</div>
    </div>
  );
}
